import PropTypes from "prop-types";
import Cookies from "js-cookie";

import { useUserData } from "src/context/userContext";

import AreYouSureButton from "src/components/buttons/AreYouSureButton/AreYouSureButton";
import { LogoutIcon } from "src/components/icons/PersonIcons";
import { useTheme } from "@mui/material";

export default function LogoutButton(props) {
  const { doSetUser } = useUserData();
  const handleLogout = async () => {
    doSetUser(null);
    localStorage.clear();
    Cookies.remove("token");
    console.log("logging out");
    window.location = "/";
  };
  const theme = useTheme();
  const color = theme.palette.appBar.text;

  return (
    <>
      <AreYouSureButton
        component="iconButton"
        onClick={handleLogout}
        aria-label="Kirjaudu ulos."
        componentProps={{ "aria-label": "Kirjaudu ulos." }}
        dialogProps={{
          title: "Kirjaudu ulos.",
          content: "",
          acceptText: "Kirjaudu ulos",
        }}
        snackbarProps={{
          doneMessage: "Kirjauduttu ulos",
          failMessage: "Kirjauduttu ulos",
          klikMessage: "Kirjaudutaan ulos",
        }}
        dontAskId="Kirjaudu ulos">
        <LogoutIcon sx={{ color: color }} />
      </AreYouSureButton>
      {!props.noText && <span>Logout</span>}
    </>
  );
}
LogoutButton.propTypes = {
  noText: PropTypes.bool,
};
